import { Component, ElementRef, ViewChild } from '@angular/core';
import { ApiServiceService } from './api-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataSharingService } from '../../Services/data-sharing.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../../shared/message-dialog/message-dialog.component';
import { ShareService } from '../../Services/share.service';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent {
  excelData: any[] | undefined;
  formData: FormData = new FormData();
  filterForm: FormGroup;
  KeywordIsvalid: boolean = false;
  Isloader: boolean = false;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  TrackBtn: string = "Track Now"

  constructor(private Service: ApiServiceService, public fb: FormBuilder, private router: Router, private dataSharingService: DataSharingService,
    public dialog: MatDialog, private _csvService: ShareService
  ) {
    this.filterForm = this.fb.group({
      Keyword: ['', [Validators.required]],
      SearchBy: ['']
    });
  }

  ngOnInit(): void {
    localStorage.removeItem('trackingDetails');
  }


  keywordchanged(): void {
    const keywordValue = this.filterForm.controls['Keyword'].value.toString().toLowerCase();
    if (keywordValue.includes('xpo') || keywordValue.includes('xpl')) {
      this.filterForm.controls['SearchBy'].setValue('OrderId');
      this.KeywordIsvalid = true;
    } else if (keywordValue.includes('xpcn')) {
      this.filterForm.controls['SearchBy'].setValue('XPCN');
      this.KeywordIsvalid = true;
    } else if (keywordValue.includes('xpls')) {
      this.filterForm.controls['SearchBy'].setValue('XPLS');
      this.KeywordIsvalid = true;
    } else {
      this.filterForm.controls['SearchBy'].setValue('XPCN');
      this.KeywordIsvalid = true;
    }
  }

  downloadSampleExcel() {
    this.excelData = [];
    this.excelData.push({
      'XPCN': '1000028384'
    });
    this.excelData.push({
      'XPCN': '1000028384'
    });
    this.excelData.push({
      'XPCN': '1000028384'
    });
    this.excelData.push({
      'XPCN': '1000028384'
    });
    this.excelData.push({
      'XPCN': '1000028384'
    });
    this._csvService.exportAsCsvFile(this.excelData, 'Tracking Sample')
  }
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const trimmedText = pastedText.trim();
    document.execCommand('insertText', false, trimmedText);
  }

  onSubmit(): void {
    if (this.filterForm.valid) {
      this.Isloader = true;
      console.log(this.TrackBtn);
      if (this.TrackBtn == 'Track Now')
        this.Service.getDetails(this.filterForm.value).subscribe((data: any) => {
          this.Isloader = false;
          if (data['Success']) {
            if (data['Data'] != null) {
              if (data['Data']['OrderId'] != null) {
                if ((data['Data']['DepartedOrigin'] == null || data['Data']['DepartedOrigin'] == "") && (data['Data']['IsTripClosed'] == false)) {
                  this.dialog.open(MessageDialogComponent, {
                    width: '250px',
                    data: { Message: "The Trip is Not Started Yet!", icon: "fa fa-times error-icon" }
                  });
                }
                else if (data['Data']['IsCancelled'] == true) {
                  this.dialog.open(MessageDialogComponent, {
                    width: '250px',
                    data: { Message: "The Trip is Cancelled!", icon: "fa fa-times error-icon" }
                  });
                }
                else {
                  this.dataSharingService.setData(data['Data']);
                  this.router.navigate(['/track'], {
                    queryParams: { order: this.filterForm.value.Keyword }
                  });
                }
              }
              else {
                this.dialog.open(MessageDialogComponent, {
                  width: '250px',
                  data: { Message: "Please Enter Valid Input !", icon: "fa fa-times error-icon" }
                });

              }
            }
            else {

            }

          }
          else {
            this.dialog.open(MessageDialogComponent, {
              width: '250px',
              data: { Message: "Please Enter Correct Detail", icon: "fa fa-times error-icon" }
            });
          }
        })
      else if (this.TrackBtn === 'DOWNLOAD CSV') {
        this.Service.csvUpload(this.formData).subscribe(
          (data: Blob) => {
            this.Isloader = false;
            const url = window.URL.createObjectURL(data);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'TrackingDetails.csv';
            a.click();
            window.URL.revokeObjectURL(url);
            this.TrackBtn = 'Track Now';
            this.filterForm.reset();
          },
          (error: any) => {
            console.error('Error while downloading the file:', error);
            this.TrackBtn = 'Track Now';
            this.filterForm.reset();
          });
      }
    }
  }


  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const validFileTypes = ['text/csv', 'application/vnd.ms-excel'];
      const maxSizeInBytes = 1 * 1024 * 1024;

      if (!validFileTypes.includes(file.type)) {
        this.dialog.open(MessageDialogComponent, {
          width: '300px',
          data: { Message: "Invalid file type. Please upload a CSV file.", icon: "fa fa-times error-icon" }
        });
        return;
      }

      if (file.size > maxSizeInBytes) {
        this.dialog.open(MessageDialogComponent, {
          width: '300px',
          data: { Message: "File size exceeds the limit of 1MB.", icon: "fa fa-times error-icon" }
        });
        return;
      }

      this.filterForm.controls['Keyword'].setValue(file.name);
      this.TrackBtn = "DOWNLOAD CSV";
      this.formData.delete('file'); // Clear any existing file
      this.formData.append('fileData', file); // Append the file directly
    }
  }
}
